import { Select } from '../../components/Select'
import { LABELS, PLACEHOLDERS, TOptionsResponse } from '../../constants'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  fetchCCOptions,
  fetchFacilityOptions
} from '../../pages/Compliance/api'
import { TGroup } from '../../components/Select/types'
import { TOptionsFacilityResponse } from '../../pages/Compliance/types'
import { useComplianceContext } from '../../pages/Compliance/Providers/ComplianceContextProvider'
import { getUser } from '../../redux/store/user/getters'

const HeaderFilters = () => {
  const { setSelectedCategories, setSelectedFacilities } =
    useComplianceContext().actions
  const user = useSelector(getUser)
  const canSeeHealthSystem = !user.outside_community
  const [categoryOptions, setCategoryOptions] = useState<TOptionsResponse[]>([])
  const [facilitiesOptions, setFacilitiesOptions] = useState<
    TOptionsFacilityResponse[]
  >([])

  useEffect(() => {
    fetchCCOptions().then((res) => {
      setCategoryOptions(res?.data?.results)
    })
    fetchFacilityOptions().then((res) => {
      setFacilitiesOptions(res?.data?.results)
    })
  }, [])

  const returnGroupedOptions = (arr: TOptionsFacilityResponse[]): TGroup[] => {
    if (arr?.length) {
      return Object.values(
        arr.reduce(
          (p, n) => ({
            ...p,
            [n.health_system]: {
              label: n.health_system,
              options: [
                ...(p[n.health_system]?.options || []),
                {
                  value: n.id,
                  key: n.id,
                  label: n.value
                }
              ]
            }
          }),
          {}
        )
      )
    }
    return []
  }

  const returnFlatOptions = (arr: TOptionsFacilityResponse[]) =>
    arr?.length
      ? arr.map((n) => ({ value: n.id, key: n.id, label: n.value }))
      : []

  return (
    <div className="compliance-container__header-filters row gap-8">
      <Select.Multi
        options={categoryOptions.map((option) => ({
          value: option.id,
          label: option.value
        }))}
        propsItem={{
          name: 'categories',
          label: LABELS.CATEGORIES
        }}
        propsSelect={{
          placeholder: PLACEHOLDERS.ALL,
          onChange: setSelectedCategories
        }}
      />
      <Select.Multi
        options={
          canSeeHealthSystem
            ? returnGroupedOptions(facilitiesOptions)
            : returnFlatOptions(facilitiesOptions)
        }
        propsItem={{
          name: 'facilities',
          label: LABELS.FACILITIES
        }}
        propsSelect={{
          placeholder: PLACEHOLDERS.ALL,
          onChange: setSelectedFacilities
        }}
      />
    </div>
  )
}
export default HeaderFilters
